import styles from './Separator.module.scss'

const Separator = () => <div className={styles.separator} />

export default Separator
